import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { lookupPhoneNumber } from '../../api/crmApi';

import { phoneLookupKeys } from './keys';

export const phoneLookupOptions = (phoneNumber) =>
	queryOptions({
		queryKey: phoneLookupKeys.byNumber(phoneNumber),
		queryFn: () => lookupPhoneNumber(phoneNumber),
		// CRM master data changes rarely; a caller's identity is stable for the call's lifetime.
		staleTime: STALE_TIMES.STABLE,
		// A failed lookup must not raise a global toast — it degrades silently to "just the number".
		meta: { suppressGlobalError: true },
	});

/**
 * Resolves an incoming caller's phone number to matching CRM contacts/companies.
 * Pass `enabled: false` (e.g. for outbound calls or when no number is known) to skip the request.
 *
 * @param {string} phoneNumber - The external party's number, in any format
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true] - Whether the query should run
 */
export function usePhoneLookup(phoneNumber, { enabled = true } = {}) {
	return useQuery({
		...phoneLookupOptions(phoneNumber),
		enabled: enabled && Boolean(phoneNumber),
	});
}
